var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('IconTooltip',{attrs:{"className":_vm.$style.svgPosition,"contentContainerClass":_vm.$style.contentContainer,"iconClass":_vm.$style[_vm.state.iconClass],"iconComponent":_vm.state.icon}},[(_vm.state.tooltip)?_c('div',[_vm._v(" "+_vm._s(_vm.state.tooltip)+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }